(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["cart"]) return;
  try {
    
  document.querySelectorAll('.cart-page__quantity-input').forEach(function (input) {
    input.addEventListener('change', function () {
      var form = input.closest('form');
      if (form && form.requestSubmit) {
        form.requestSubmit();
      } else if (form) {
        form.submit();
      }
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection"]) return;
  try {
    
  document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      select.form.submit();
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["depict-patched-collection"]) return;
  try {
      document.querySelectorAll('[data-sort-select]').forEach(function (select) {
    select.addEventListener('change', function () {
      select.form.submit();
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-chip-tuning"]) return;
  try {
    
  document.querySelectorAll('[data-chip-tuning-yesno]').forEach(function (group) {
    var description = group.querySelector('[data-chip-tuning-yesno-description]');
    var textarea = description.querySelector('textarea');
    group.querySelectorAll('[data-chip-tuning-yesno-input]').forEach(function (input) {
      input.addEventListener('change', function () {
        var show = input.value === 'yes' && input.checked;
        description.classList.toggle('is-expanded', show);
        if (!show) textarea.value = '';
      });
    });
  });

  document.querySelectorAll('[data-chip-tuning-form]').forEach(function (form) {
    var endpoint = form.getAttribute('data-endpoint');
    var logoUrl = form.getAttribute('data-logo-url');
    var shopUrl = form.getAttribute('data-shop-url');
    var fieldsWrap = form.querySelector('[data-chip-tuning-fields]');
    var successBox = form.querySelector('[data-chip-tuning-success]');
    var errorBox = form.querySelector('[data-chip-tuning-error]');
    var submitButton = form.querySelector('[data-chip-tuning-submit]');

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      errorBox.hidden = true;

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var formData = new FormData(form);
      var payload = {};
      formData.forEach(function (value, key) {
        payload[key] = value;
      });
      payload.logoUrl = logoUrl;
      payload.shopUrl = shopUrl;

      submitButton.disabled = true;
      var sendingLabel = submitButton.getAttribute('data-label-sending');
      if (sendingLabel) submitButton.textContent = sendingLabel;

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok && data.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) throw new Error('request failed');
          fieldsWrap.hidden = true;
          successBox.hidden = false;
        })
        .catch(function () {
          errorBox.textContent = errorBox.getAttribute('data-fallback-text');
          errorBox.hidden = false;
          submitButton.disabled = false;
          var defaultLabel = submitButton.getAttribute('data-label-default');
          if (defaultLabel) submitButton.textContent = defaultLabel;
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["page-contact"]) return;
  try {
    
  document.querySelectorAll('[data-contact-form]').forEach(function (form) {
    var endpoint = form.getAttribute('data-endpoint');
    var logoUrl = form.getAttribute('data-logo-url');
    var shopUrl = form.getAttribute('data-shop-url');
    var fieldsWrap = form.querySelector('[data-contact-fields]');
    var successBox = form.querySelector('[data-contact-success]');
    var errorBox = form.querySelector('[data-contact-error]');
    var submitButton = form.querySelector('[data-contact-submit]');

    form.addEventListener('submit', function (event) {
      event.preventDefault();
      errorBox.hidden = true;

      if (!form.checkValidity()) {
        form.reportValidity();
        return;
      }

      var formData = new FormData(form);
      var payload = { type: 'contact', logoUrl: logoUrl, shopUrl: shopUrl };
      formData.forEach(function (value, key) {
        payload[key] = value;
      });

      submitButton.disabled = true;
      var sendingLabel = submitButton.getAttribute('data-label-sending');
      if (sendingLabel) submitButton.textContent = sendingLabel;

      fetch(endpoint, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(payload),
      })
        .then(function (response) {
          return response.json().then(function (data) {
            return { ok: response.ok && data.ok, data: data };
          });
        })
        .then(function (result) {
          if (!result.ok) throw new Error('request failed');
          fieldsWrap.hidden = true;
          successBox.hidden = false;
        })
        .catch(function () {
          errorBox.textContent = errorBox.getAttribute('data-fallback-text');
          errorBox.hidden = false;
          submitButton.disabled = false;
          var defaultLabel = submitButton.getAttribute('data-label-default');
          if (defaultLabel) submitButton.textContent = defaultLabel;
        });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["product"]) return;
  try {
    
  // See theme.js/cart.js — same guarded shared scroll-lock counter,
  // duplicated because section-scoped JS bundling order relative to
  // those asset files isn't guaranteed.
  window.HarpiaScrollLock = window.HarpiaScrollLock || (function () {
    var locks = new Set();
    return {
      lock: function (id) {
        locks.add(id);
        document.documentElement.setAttribute('data-scroll-lock', '');
      },
      unlock: function (id) {
        locks.delete(id);
        if (locks.size === 0) document.documentElement.removeAttribute('data-scroll-lock');
      }
    };
  })();

  (function () {
    var form = document.querySelector('[data-product-form]');
    if (!form) return;

    var variantsScript = document.querySelector('[data-product-variants-json]');
    var variants = [];
    try {
      variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    } catch (error) {
      variants = [];
    }

    var optionSelects = Array.prototype.slice.call(form.querySelectorAll('[data-option-index]'));
    var idInput = form.querySelector('[data-product-form-id]');
    var submitButton = form.querySelector('[data-product-submit]');
    var submitText = form.querySelector('[data-submit-text]');
    var priceCurrent = document.querySelector('[data-price-current]');
    var priceCompare = document.querySelector('[data-price-compare]');
    var saleBadge = document.querySelector('[data-price-sale-badge]');
    var saleBadgePercent = document.querySelector('[data-price-sale-percent]');
    var skuRow = document.querySelector('[data-product-sku]');
    var gallery = document.querySelector('[data-product-gallery]');
    var galleryMain = gallery ? gallery.querySelector('.product__gallery-main') : null;

    // `scroll: true` is only for a programmatic jump (thumbnail click,
    // variant switch) — left false when called FROM the scroll listener
    // itself below, or every swipe would fight its own momentum trying
    // to re-scroll to the slide it's already settling on.
    function activateMedia(mediaId, scroll) {
      if (!gallery || !mediaId) return;
      var id = String(mediaId);
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.classList.toggle('is-active', thumb.getAttribute('data-media-id') === id);
      });
      var slides = gallery.querySelectorAll('[data-gallery-slide]');
      slides.forEach(function (slide) {
        var isMatch = slide.getAttribute('data-media-id') === id;
        slide.classList.toggle('is-active', isMatch);
        if (isMatch && scroll && galleryMain) {
          galleryMain.scrollTo({ left: slide.offsetLeft, behavior: 'smooth' });
        }
      });
    }

    if (galleryMain) {
      var swipeHint = gallery.querySelector('[data-gallery-swipe-hint]');
      if (swipeHint) {
        galleryMain.addEventListener(
          'scroll',
          function () {
            swipeHint.classList.add('is-dismissed');
          },
          { passive: true, once: true }
        );
      }

      var scrollSyncRaf = null;
      galleryMain.addEventListener('scroll', function () {
        if (scrollSyncRaf) return;
        scrollSyncRaf = requestAnimationFrame(function () {
          scrollSyncRaf = null;
          var slides = gallery.querySelectorAll('[data-gallery-slide]');
          if (!slides.length) return;
          var index = Math.round(galleryMain.scrollLeft / galleryMain.clientWidth);
          index = Math.max(0, Math.min(slides.length - 1, index));
          var current = slides[index];
          if (current && !current.classList.contains('is-active')) {
            activateMedia(current.getAttribute('data-media-id'), false);
          }
        });
      }, { passive: true });
    }

    function findMatchingVariant() {
      var ordered = optionSelects.slice().sort(function (a, b) {
        return Number(a.getAttribute('data-option-index')) - Number(b.getAttribute('data-option-index'));
      });
      var selected = ordered.map(function (select) { return select.value; });

      return variants.filter(function (variant) {
        return variant.options.every(function (value, index) { return value === selected[index]; });
      })[0];
    }

    function updateForVariant(variant) {
      if (!variant) {
        if (idInput) idInput.value = '';
        if (submitButton) {
          submitButton.disabled = true;
          if (submitText) submitText.textContent = submitButton.getAttribute('data-label-unavailable');
        }
        return;
      }

      if (idInput) idInput.value = variant.id;
      if (priceCurrent) priceCurrent.textContent = variant.price_html;

      if (priceCompare) {
        priceCompare.hidden = !variant.on_sale;
        if (variant.on_sale) priceCompare.textContent = variant.compare_at_price_html;
      }

      if (saleBadge) saleBadge.hidden = !variant.on_sale;
      if (saleBadgePercent && variant.on_sale) saleBadgePercent.textContent = '-' + variant.discount_percent + '%';
      if (skuRow) skuRow.textContent = variant.sku || '';

      if (submitButton) {
        submitButton.disabled = !variant.available;
        if (submitText) {
          submitText.textContent = variant.available
            ? submitButton.getAttribute('data-label-available')
            : submitButton.getAttribute('data-label-soldout');
        }
      }

      if (variant.featured_media_id) activateMedia(variant.featured_media_id, true);
    }

    optionSelects.forEach(function (select) {
      select.addEventListener('change', function () {
        updateForVariant(findMatchingVariant());
      });
    });

    if (gallery) {
      gallery.querySelectorAll('[data-gallery-thumb]').forEach(function (thumb) {
        thumb.addEventListener('click', function () {
          activateMedia(thumb.getAttribute('data-media-id'), true);
        });
      });
    }

    var zoomOverlay = document.getElementById('ProductZoom');
    if (zoomOverlay && gallery) {
      function closeZoom() {
        zoomOverlay.classList.remove('is-open');
        window.HarpiaScrollLock.unlock('product-zoom');
      }

      function openZoom(mediaId) {
        var id = String(mediaId);
        zoomOverlay.querySelectorAll('[data-zoom-slide]').forEach(function (slide) {
          var isMatch = slide.getAttribute('data-media-id') === id;
          slide.classList.toggle('is-active', isMatch);
          slide.classList.remove('is-zoomed');
          var img = slide.querySelector('img');
          if (img) img.style.transformOrigin = '';
        });
        zoomOverlay.classList.add('is-open');
        window.HarpiaScrollLock.lock('product-zoom');
      }

      gallery.querySelectorAll('[data-gallery-zoom-trigger]').forEach(function (trigger) {
        trigger.addEventListener('click', function () {
          var slide = trigger.closest('[data-gallery-slide]');
          if (slide) openZoom(slide.getAttribute('data-media-id'));
        });
      });

      zoomOverlay.querySelectorAll('[data-product-zoom-close]').forEach(function (el) {
        el.addEventListener('click', closeZoom);
      });

      zoomOverlay.querySelectorAll('[data-zoom-slide] img').forEach(function (img) {
        img.addEventListener('click', function (event) {
          var slide = img.closest('[data-zoom-slide]');
          if (slide.classList.contains('is-zoomed')) {
            slide.classList.remove('is-zoomed');
            return;
          }
          var rect = img.getBoundingClientRect();
          var x = ((event.clientX - rect.left) / rect.width) * 100;
          var y = ((event.clientY - rect.top) / rect.height) * 100;
          img.style.transformOrigin = x + '% ' + y + '%';
          slide.classList.add('is-zoomed');
        });
      });

      document.addEventListener('keydown', function (event) {
        if (event.key === 'Escape') closeZoom();
      });
    }

    var recommendations = document.querySelector('[data-product-recommendations]');
    if (recommendations) {
      var url = recommendations.getAttribute('data-url');
      if (url) {
        fetch(url)
          .then(function (response) { return response.text(); })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html');
            var content = doc.querySelector('[data-product-recommendations-content]');
            if (content) recommendations.outerHTML = content.outerHTML;
          })
          .catch(function () {});
      }
    }
  })();

  } catch(e) { console.error(e); }
})();
})();
